import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import SectorsReadOnly from '../components/SectorsReadOnly';

const SectorsPage = () => {
  return (
    <>
      <h2 className={'TitleGrid'}>
        <Trans>Capacitaciones pendientes por sector</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <SectorsReadOnly />
    </>
  );
};

export default SectorsPage;
